import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "./authConfig";

class MsalSingleton {
  private static instance: PublicClientApplication | null = null;

  public static getInstance(): PublicClientApplication {
    if (!MsalSingleton.instance) {
      MsalSingleton.instance = new PublicClientApplication(msalConfig);
    }
    return MsalSingleton.instance;
  }
}

export const msalInstance = MsalSingleton.getInstance();
